<div class="m2 pl2">
  <h1>Flags</h1>
  <mat-selection-list class="col-10 mx-auto" (selectionChange)="change($event)">
    <mat-list-option *ngFor="let flag of flags" [selected]="flag.get()" [value]="flag.name">
      <b>{{ flag.title }}</b
      ><br /><small>{{ flag.description }}</small>
    </mat-list-option>
  </mat-selection-list>
</div>
